var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { REFRESH_PATCHWORK_REQUEST, LOAD_PATCHWORK_REQUEST, LOAD_PATCHWORK_SUCCESS, LOAD_PATCHWORK_FAILURE, DELETE_PATCH_REQUEST, DELETE_PATCH_SUCCESS, DELETE_PATCH_FAILURE, CREATE_PATCH_REQUEST, CREATE_PATCH_SUCCESS, CREATE_PATCH_FAILURE, UPDATE_PATCH_REQUEST, UPDATE_PATCH_SUCCESS, UPDATE_PATCH_FAILURE, CREATE_EDGE_REQUEST, CREATE_EDGE_SUCCESS, CREATE_EDGE_FAILURE, UPDATE_EDGE_REQUEST, UPDATE_EDGE_SUCCESS, UPDATE_EDGE_FAILURE, DELETE_EDGE_REQUEST, DELETE_EDGE_SUCCESS, DELETE_EDGE_FAILURE, LOAD_VIEW_REQUEST, LOAD_VIEW_SUCCESS, LOAD_VIEW_FAILURE, LOAD_DATASET_REQUEST, LOAD_DATASET_SUCCESS, LOAD_DATASET_FAILURE, LOAD_GROUPS_FAILURE, LOAD_GROUPS_REQUEST, LOAD_GROUPS_SUCCESS, LOAD_ICONS_REQUEST, LOAD_ICONS_SUCCESS, LOAD_ICONS_FAILURE, LOAD_DATASET_ROWS_REQUEST, LOAD_DATASET_ROWS_SUCCESS, LOAD_DATASET_ROWS_FAILURE, SET_LOADING_STATE, UPDATE_CANVAS_OFFSET, UPDATE_PATCHWORK_ENTRYPOINT, UPDATE_PATCHWORK_ENTRYPOINT_SUCCESS, UPDATE_PATCHWORK_ENTRYPOINT_FAIL, LOAD_INTEGRATION_REQUEST, LOAD_INTEGRATION_SUCCESS, LOAD_INTEGRATION_FAILURE, SET_VIEW_DEFAULT_STATE, SELECT_GROUP, SELECT_GROUP_CHANGING, COPY_LOGIC_REQUEST, COPY_LOGIC_SUCCESS, COPY_LOGIC_FAILURE, COPY_LOGIC_GROUP_REQUEST, COPY_LOGIC_GROUP_SUCCESS, COPY_LOGIC_GROUP_FOCAL_PATCH, COPY_LOGIC_GROUP_FAILURE, CREATE_VIEW_REQUEST, CREATE_VIEW_SUCCESS, CREATE_VIEW_FAILURE, CREATE_VIEW_EVENT_REQUEST, CREATE_VIEW_EVENT_SUCCESS, CREATE_VIEW_EVENT_FAILURE, CHANGE_VIEW_NAME_SUCCESS, CHANGE_VIEW_NAME_REQUEST, CHANGE_VIEW_NAME_FAILURE, UPDATE_PATCH_COORDS_REQUEST, UPDATE_PATCH_COORDS_SUCCESS, UPDATE_PATCH_COORDS_FAILURE, UPDATE_PATCHWORK_REQUEST, UPDATE_PATCHWORK_SUCCESS, UPDATE_PATCHWORK_FAILURE, BULK_DELETE_PATCHES_REQUEST, BULK_DELETE_PATCHES_SUCCESS, BULK_DELETE_PATCHES_FAILURE, } from './constants';
import services from '../../services';
import { appendOutToName, cleanEdgeArgName, cleanPatchOutputs, } from './helpers';
import toast from '../../components/Toast';
import { customLogicReadAllAction } from '../../store/logicBuilder/actions';
import { updateDatasetsAction } from 'store/structureBuilder/actions';
var PatchworkService = services.PatchworkService, ViewService = services.ViewService, DatasetService = services.DatasetService, GroupService = services.GroupService, MediaService = services.MediaService, IntegrationService = services.IntegrationService;
export var getViews = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var views, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: LOAD_VIEW_REQUEST,
                });
                return [4 /*yield*/, ViewService.getViews(appId)];
            case 1:
                views = (_a.sent()).objects;
                dispatch({
                    type: LOAD_VIEW_SUCCESS,
                    views: views,
                });
                return [3 /*break*/, 3];
            case 2:
                err_1 = _a.sent();
                dispatch({
                    type: LOAD_VIEW_FAILURE,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var createView = function (newView, appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var view, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: CREATE_VIEW_REQUEST });
                return [4 /*yield*/, ViewService.createView(newView, appId)];
            case 1:
                view = (_a.sent()).object;
                dispatch({ type: CREATE_VIEW_SUCCESS, view: view });
                return [3 /*break*/, 3];
            case 2:
                err_2 = _a.sent();
                dispatch({ type: CREATE_VIEW_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var clearCreatedNewViewData = function (dispatch) {
    dispatch({ type: CREATE_VIEW_SUCCESS, view: false });
};
export var createViewEvent = function (eventName, viewId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var view, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                dispatch({
                    type: CREATE_VIEW_EVENT_REQUEST,
                });
                return [4 /*yield*/, ViewService.getView(viewId)];
            case 1:
                view = (_a.sent()).object;
                if (!view) return [3 /*break*/, 3];
                return [4 /*yield*/, ViewService.updateView({
                        name: view.name,
                        bgColor: view.background_color,
                        bgImage: view.background_image,
                        padding: view.padding,
                        savedLayout: view.layout,
                        inputs: view.inputs,
                        outputs: __spreadArray(__spreadArray([], view.outputs, true), [{ name: eventName, type: 'event' }], false),
                        viewId: view.id,
                        settings: view.settings,
                    })];
            case 2:
                _a.sent();
                dispatch({
                    type: CREATE_VIEW_EVENT_SUCCESS,
                });
                _a.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                err_3 = _a.sent();
                dispatch({
                    type: CREATE_VIEW_EVENT_FAILURE,
                });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var updateViewName = function (viewName, viewId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var view, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                dispatch({ type: CHANGE_VIEW_NAME_REQUEST });
                return [4 /*yield*/, ViewService.getView(viewId)];
            case 1:
                view = (_a.sent()).object;
                if (!view) return [3 /*break*/, 3];
                return [4 /*yield*/, ViewService.updateView({
                        name: viewName,
                        bgColor: view.background_color,
                        bgImage: view.background_image,
                        padding: view.padding,
                        savedLayout: view.layout,
                        inputs: view.inputs,
                        outputs: view.outputs,
                        viewId: view.id,
                        settings: view.settings,
                    })];
            case 2:
                _a.sent();
                dispatch({
                    type: CHANGE_VIEW_NAME_SUCCESS,
                    payload: { viewName: viewName, viewId: view.id },
                });
                _a.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                err_4 = _a.sent();
                dispatch({ type: CHANGE_VIEW_NAME_FAILURE });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var getDatasets = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasets, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: LOAD_DATASET_REQUEST,
                });
                return [4 /*yield*/, DatasetService.listDatasets(appId)];
            case 1:
                datasets = (_a.sent()).objects;
                dispatch({
                    type: LOAD_DATASET_SUCCESS,
                    datasets: datasets,
                });
                dispatch(updateDatasetsAction(datasets));
                return [3 /*break*/, 3];
            case 2:
                err_5 = _a.sent();
                dispatch({
                    type: LOAD_DATASET_FAILURE,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getDatasetRows = function (datasetId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var datasetRows, err_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: LOAD_DATASET_ROWS_REQUEST });
                return [4 /*yield*/, DatasetService.getRows(datasetId)];
            case 1:
                datasetRows = (_a.sent()).objects;
                dispatch({ type: LOAD_DATASET_ROWS_SUCCESS, datasetRows: datasetRows, datasetId: datasetId });
                return [3 /*break*/, 3];
            case 2:
                err_6 = _a.sent();
                dispatch({ type: LOAD_DATASET_ROWS_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var getPatchwork = function (appId, isRefresh) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, meta, patchwork, err_7;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({
                    type: isRefresh ? REFRESH_PATCHWORK_REQUEST : LOAD_PATCHWORK_REQUEST,
                });
                return [4 /*yield*/, PatchworkService.readPatchworkByAppId(appId)];
            case 1:
                _a = _b.sent(), meta = _a.meta, patchwork = _a.object;
                dispatch({
                    type: LOAD_PATCHWORK_SUCCESS,
                    patchwork: patchwork,
                    meta: meta,
                });
                return [3 /*break*/, 3];
            case 2:
                err_7 = _b.sent();
                dispatch({ type: LOAD_PATCHWORK_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var updatePatchwork = function (patchworkId, patchwork) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var newPatchwork, err_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: UPDATE_PATCHWORK_ENTRYPOINT });
                return [4 /*yield*/, PatchworkService.updatePatchwork(patchworkId, patchwork)];
            case 1:
                newPatchwork = (_a.sent()).object;
                dispatch({
                    type: UPDATE_PATCHWORK_ENTRYPOINT_SUCCESS,
                    entrypoint: newPatchwork.entrypoint,
                });
                return [3 /*break*/, 3];
            case 2:
                err_8 = _a.sent();
                dispatch({ type: UPDATE_PATCHWORK_ENTRYPOINT_FAIL });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var createPatch = function (patchworkId, patch) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var newPatch, err_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: CREATE_PATCH_REQUEST });
                if (patch.type === 'dataset') {
                    patch.settings.layout = 'list';
                }
                if (patch.type !== 'logic') {
                    if (patch.type !== 'view' && patch.type !== 'list') {
                        patch.settings.topBarBehavior = 'visible';
                    }
                    else
                        patch.settings.topBarBehavior = 'inherit';
                }
                patch = cleanPatchOutputs(patch);
                patch.x = Math.floor(patch.x);
                patch.y = Math.floor(patch.y);
                return [4 /*yield*/, PatchworkService.createPatch(patchworkId, patch)];
            case 1:
                newPatch = (_a.sent()).object;
                dispatch({
                    type: CREATE_PATCH_SUCCESS,
                    patch: newPatch,
                });
                return [3 /*break*/, 3];
            case 2:
                err_9 = _a.sent();
                dispatch({ type: CREATE_PATCH_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deletePatch = function (appId, patchworkId, patchId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({ type: DELETE_PATCH_REQUEST });
                return [4 /*yield*/, PatchworkService.deletePatch(patchworkId, patchId)];
            case 1:
                _a.sent();
                return [4 /*yield*/, getPatchwork(appId, true)];
            case 2:
                _a.sent();
                dispatch({ type: DELETE_PATCH_SUCCESS });
                toast.success("Patch deleted successfully");
                return [3 /*break*/, 4];
            case 3:
                err_10 = _a.sent();
                dispatch({ type: DELETE_PATCH_FAILURE });
                toast.error("Failed to delete Patch");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var deletePatches = function (appId, patchworkId, patches) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({ type: BULK_DELETE_PATCHES_REQUEST });
                return [4 /*yield*/, PatchworkService.bulkDeletePatches(patchworkId, patches)];
            case 1:
                _a.sent();
                return [4 /*yield*/, getPatchwork(appId, true)];
            case 2:
                _a.sent();
                toast.success("Patch deleted successfully");
                dispatch({ type: BULK_DELETE_PATCHES_SUCCESS });
                return [3 /*break*/, 4];
            case 3:
                err_11 = _a.sent();
                toast.error("Failed to delete Patch");
                dispatch({ type: BULK_DELETE_PATCHES_FAILURE });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var updatePatch = function (patchworkId, patchId, patch) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var newPatches, err_12;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                if (!(patchworkId && patchId)) return [3 /*break*/, 2];
                dispatch({ type: UPDATE_PATCH_REQUEST, patch: patch });
                patch = cleanPatchOutputs(patch);
                patch.x = Math.floor(patch.x);
                patch.y = Math.floor(patch.y);
                return [4 /*yield*/, PatchworkService.updatePatch(patchworkId, patchId, patch)];
            case 1:
                newPatches = (_b.sent()).object;
                dispatch({
                    type: UPDATE_PATCH_SUCCESS,
                    patch: ((_a = newPatches === null || newPatches === void 0 ? void 0 : newPatches.patches) === null || _a === void 0 ? void 0 : _a.find(function (p) { return p.id === patchId; })) || [],
                });
                _b.label = 2;
            case 2: return [3 /*break*/, 4];
            case 3:
                err_12 = _b.sent();
                dispatch({ type: UPDATE_PATCH_FAILURE });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var createNewCustomLogicWithPatch = function (appId, patchworkId, createdPatch, edge) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var modifiedPatchwork, newPatch, originalEdge, err_13;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 5, , 6]);
                dispatch({ type: UPDATE_PATCHWORK_REQUEST });
                return [4 /*yield*/, PatchworkService.createNewCustomLogicWithPatch(appId, patchworkId, createdPatch, [{ name: 'in:__view__', type: 'event', value: {} }])];
            case 1:
                modifiedPatchwork = (_b.sent()).object;
                newPatch = (_a = modifiedPatchwork === null || modifiedPatchwork === void 0 ? void 0 : modifiedPatchwork.patches) === null || _a === void 0 ? void 0 : _a.find(function (patch) { var _a; return ((_a = patch === null || patch === void 0 ? void 0 : patch.settings) === null || _a === void 0 ? void 0 : _a.toSync) && (patch === null || patch === void 0 ? void 0 : patch.name) === (createdPatch === null || createdPatch === void 0 ? void 0 : createdPatch.name); });
                return [4 /*yield*/, dispatch({
                        type: UPDATE_PATCHWORK_SUCCESS,
                        patchwork: modifiedPatchwork,
                    })];
            case 2:
                _b.sent();
                if (!(newPatch && (edge === null || edge === void 0 ? void 0 : edge.from_patch))) return [3 /*break*/, 4];
                originalEdge = cleanEdgeArgName(__assign(__assign({}, edge), { to_patch: newPatch.id, to_arg: 'in:__view__' }));
                return [4 /*yield*/, dispatch(createEdge(patchworkId, originalEdge))];
            case 3:
                _b.sent();
                _b.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                err_13 = _b.sent();
                dispatch({ type: UPDATE_PATCHWORK_FAILURE });
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
export var createCustomLogicPatchWithLogicPatches = function (appId, patchworkId, patchName, logicPatches, inputs, outputs) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var modifiedPatchwork, err_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    dispatch({ type: UPDATE_PATCHWORK_REQUEST });
                    return [4 /*yield*/, PatchworkService.createCustomLogicPatchWithLogicPatches(appId, patchworkId, patchName, logicPatches, inputs, outputs)];
                case 1:
                    modifiedPatchwork = (_a.sent()).object;
                    dispatch({
                        type: UPDATE_PATCHWORK_SUCCESS,
                        patchwork: modifiedPatchwork,
                    });
                    return [4 /*yield*/, dispatch(customLogicReadAllAction(appId))];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, dispatch(getPatchwork(appId))];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_14 = _a.sent();
                    dispatch({ type: UPDATE_PATCHWORK_FAILURE });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
};
export var updatePatchCoordinates = function (patchworkId, batch) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var modifiedPatchwork, err_15;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: UPDATE_PATCH_COORDS_REQUEST });
                return [4 /*yield*/, PatchworkService.updatePatchCoordinates(patchworkId, batch)];
            case 1:
                modifiedPatchwork = (_a.sent()).object;
                dispatch({
                    type: UPDATE_PATCH_COORDS_SUCCESS,
                    patchwork: modifiedPatchwork,
                });
                return [3 /*break*/, 3];
            case 2:
                err_15 = _a.sent();
                dispatch({ type: UPDATE_PATCH_COORDS_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var createEdge = function (patchworkId, edge) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var newEdge, err_16;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: CREATE_EDGE_REQUEST });
                edge.from_arg = appendOutToName(edge.from_arg);
                return [4 /*yield*/, PatchworkService.createEdge(patchworkId, edge)];
            case 1:
                newEdge = (_a.sent()).object;
                dispatch({
                    type: CREATE_EDGE_SUCCESS,
                    edge: newEdge,
                });
                return [3 /*break*/, 3];
            case 2:
                err_16 = _a.sent();
                dispatch({ type: CREATE_EDGE_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var updateEdge = function (patchworkId, edgeId, edge) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var cleanEdge, newEdge, err_17;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: UPDATE_EDGE_REQUEST });
                cleanEdge = __assign(__assign({}, edge), { from_arg: appendOutToName(edge.from_arg) });
                return [4 /*yield*/, PatchworkService.updateEdge(patchworkId, edgeId, cleanEdge)];
            case 1:
                newEdge = (_a.sent()).object;
                dispatch({
                    type: UPDATE_EDGE_SUCCESS,
                    edge: newEdge,
                });
                return [3 /*break*/, 3];
            case 2:
                err_17 = _a.sent();
                dispatch({ type: UPDATE_EDGE_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var deleteEdge = function (patchworkId, edgeId, checkMissingParams) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var err_18;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({
                    type: DELETE_EDGE_REQUEST,
                });
                return [4 /*yield*/, PatchworkService.deleteEdge(patchworkId, edgeId)];
            case 1:
                _a.sent();
                return [4 /*yield*/, checkMissingParams()];
            case 2:
                _a.sent();
                dispatch({
                    type: DELETE_EDGE_SUCCESS,
                    edgeId: edgeId,
                });
                return [3 /*break*/, 4];
            case 3:
                err_18 = _a.sent();
                dispatch({
                    type: DELETE_EDGE_FAILURE,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var getAppGroups = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, groups, meta, err_19;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                dispatch({ type: LOAD_GROUPS_REQUEST });
                return [4 /*yield*/, GroupService.listAppGroups(appId)];
            case 1:
                _a = _b.sent(), groups = _a.objects, meta = _a.meta;
                dispatch({ type: LOAD_GROUPS_SUCCESS, groups: groups, meta: meta });
                return [3 /*break*/, 3];
            case 2:
                err_19 = _b.sent();
                dispatch({ type: LOAD_GROUPS_FAILURE });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, null];
        }
    });
}); }; };
export var getIcons = function (scope) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var files, icons, err_20;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({ type: LOAD_ICONS_REQUEST });
                return [4 /*yield*/, MediaService.getFiles(scope)];
            case 1:
                files = (_a.sent()).objects;
                icons = files.filter(function (file) { return file.mime_type === 'image/svg+xml'; });
                dispatch({ type: LOAD_ICONS_SUCCESS, icons: icons });
                return [3 /*break*/, 3];
            case 2:
                err_20 = _a.sent();
                dispatch({ type: LOAD_ICONS_FAILURE, err: err_20 });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var setLoadingState = function () { return function (dispatch) {
    return dispatch({ type: SET_LOADING_STATE });
}; };
export var updateCanvasOffset = function (canvasOffset) {
    if (canvasOffset === void 0) { canvasOffset = { x: 0, y: 0 }; }
    return function (dispatch) {
        return dispatch({ type: UPDATE_CANVAS_OFFSET, canvasOffset: canvasOffset });
    };
};
export var getIntegrations = function (appId) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var integrations, err_21;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({
                    type: LOAD_INTEGRATION_REQUEST,
                });
                return [4 /*yield*/, IntegrationService.getIntegrations(appId)];
            case 1:
                integrations = (_a.sent()).objects;
                return [4 /*yield*/, Promise.all(integrations.map(function (integration) { return __awaiter(void 0, void 0, void 0, function () {
                        var methods;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, IntegrationService.getIntegrationMethods(integration.id)];
                                case 1:
                                    methods = (_a.sent()).objects;
                                    integration.methods = methods || [];
                                    return [2 /*return*/];
                            }
                        });
                    }); }))];
            case 2:
                _a.sent();
                dispatch({
                    type: LOAD_INTEGRATION_SUCCESS,
                    integrations: integrations,
                });
                return [3 /*break*/, 4];
            case 3:
                err_21 = _a.sent();
                dispatch({
                    type: LOAD_INTEGRATION_FAILURE,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var setDefaultStateFromView = function (key, value) { return ({
    type: SET_VIEW_DEFAULT_STATE,
    key: key,
    value: value,
}); };
export var selectGroup = function (groupId) { return function (dispatch) {
    dispatch({ type: SELECT_GROUP_CHANGING });
    setTimeout(function () {
        dispatch({ type: SELECT_GROUP, groupId: groupId });
    }, 50);
}; };
export var cloneMonoPatch = function (value) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var appId, patchwork, err_22;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                appId = value.appId;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                dispatch({ type: COPY_LOGIC_REQUEST, value: value });
                return [4 /*yield*/, PatchworkService.postCopiedMonoPatch(value)];
            case 2:
                patchwork = (_a.sent()).object;
                dispatch({ type: COPY_LOGIC_SUCCESS, patchwork: patchwork });
                return [4 /*yield*/, getPatchwork(appId, true)];
            case 3:
                _a.sent();
                toast.success("Successfully pasted");
                return [3 /*break*/, 5];
            case 4:
                err_22 = _a.sent();
                dispatch({ type: COPY_LOGIC_FAILURE, err: err_22 });
                toast.error("Failed to copy");
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var clonePolyPatch = function (value) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var appId, _a, patchwork, copyData, err_23;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                appId = value.appId;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 4, , 5]);
                dispatch({ type: COPY_LOGIC_GROUP_REQUEST, value: value });
                return [4 /*yield*/, PatchworkService.postCopiedPolyPatch(value)];
            case 2:
                _a = _c.sent(), patchwork = _a.object, copyData = _a.meta;
                dispatch({
                    type: COPY_LOGIC_GROUP_SUCCESS,
                    patchwork: __assign(__assign({}, patchwork), { focalPatch: ((_b = copyData === null || copyData === void 0 ? void 0 : copyData.meta_data) === null || _b === void 0 ? void 0 : _b.patch_id) || '' }),
                });
                return [4 /*yield*/, getPatchwork(appId, true)];
            case 3:
                _c.sent();
                toast.success("Successfully pasted");
                return [3 /*break*/, 5];
            case 4:
                err_23 = _c.sent();
                dispatch({ type: COPY_LOGIC_GROUP_FAILURE, err: err_23 });
                toast.error("Failed to copy");
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
export var reSetFocalPatch = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        try {
            dispatch({ type: COPY_LOGIC_GROUP_FOCAL_PATCH, copyData: {} });
        }
        catch (err) {
            dispatch({ type: COPY_LOGIC_GROUP_FAILURE, err: err });
            toast.error("Failed to copy");
        }
        return [2 /*return*/];
    });
}); }; };
